<template>
  <v-container fluid>
    <v-row ref="filtersContainer">
      <v-col cols="6" class="d-flex align-center">
        <span class="text-h5">Учредители</span>
        <v-btn class="ml-3" style="vertical-align: middle;" rounded color="primary" small
               v-if="false" @click="showForm()"
        >
          <v-icon left>mdi-plus</v-icon> Добавить
        </v-btn>
        <v-dialog v-model="formDialog" width="80vw" persistent>
          <owner-form v-if="formDialog"
                            @owner:form:saved="closeForm"
                            @owner:form:cancel="closeForm"
          ></owner-form>
        </v-dialog>
      </v-col>
    </v-row>

    <v-data-table
      :headers="nonSortableHeaders" :loading="!!fetching"
      :items="owners" :items-per-page="filter.limit"
      :height="dataTableHeight" disable-items-per-page hide-default-footer fixed-header
      no-data-text="Нет данных" loading-text="Данные загружаются"
    >
      <template #item="{item, index}">
        <tr>
          <td class="text-center">{{filter.limit * (filter.page - 1) + index + 1}}</td>
          <td>{{item.last_name}} {{item.first_name}} {{item.middle_name}}</td>
          <td class="text-right">
            <v-btn class="ml-2" text small depressed color="success" @click="showDetails(item)">
              <v-icon left small>mdi-eye</v-icon>
              Показать
            </v-btn>
            <v-btn v-if="false" class="ml-2" icon small depressed color="primary" dark @click="showForm(item)">
              <v-icon small>mdi-pen</v-icon>
            </v-btn>
            <v-btn v-if="false" class="ml-2" icon small depressed color="error" @click="askRemove(item)"
                   :loading="deleting[item.id]"
            >
              <v-icon left small>mdi-delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>

    <pagination ref="paginationContainer" :limit.sync="limit" :page.sync="page" :total-pages="totalPages"></pagination>

    <v-dialog v-if="detailDialog" fullscreen v-model="detailDialog">
      <owner-details @dialog:close="closeDetails"
                     @dialog:edit="editForm"
      ></owner-details>
    </v-dialog>
  </v-container>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex'

  const {mapState, mapActions, mapMutations} = createNamespacedHelpers('Owner')

  import OwnerDetails from '@/modules/owner/details'
  import OwnerForm from '@/modules/owner/form'

  import {hasFilter, hasDialog} from '@/mixins'

  export default {
    name: 'owner-list',

    mixins: [hasFilter, hasDialog],

    created() {
      this.fetch(this.filter)
    },

    computed: {
      ...mapState([
        'fetching',
        'data',
        'deleting',
      ]),

      headers() {
        return [
          {text: '#', align: 'center', width: '70'},
          {text: 'ФИО', value: 'name'},
          {text: 'Действия', align: 'right', sortable: false},
        ]
      },

      owners() {
        return this.data?.results || []
      },
    },

    methods: {
      ...mapActions(['fetch', 'show', 'remove']),
      ...mapMutations(['setModel']),

      showForm(item) {
        if (item && item.id) {
          this.show(item.id)
        } else {
          this.setModel({})
        }
        this.formDialog = true
      },

      editForm(item) {
        this.showForm(item)
        this.detailDialog = false
      },
    },

    mounted() {
      this.$eventBus.$emit('setTitle', 'Список учередителей')
    },

    components: {
      OwnerForm,
      OwnerDetails,
    }
  }
</script>
